import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';

import { Label, Badge } from 'react-bootstrap';
import { Cell } from 'fixed-data-table-2';

import { getColorScale } from '../../core/doc_util';
import s from './PredictionCell.css';
import Tooltip from '../Tooltip';

// Color bar showing probability
function colorCell(prob, color, showPercent) {
  const pctWidth = showPercent ? prob : 1; // range [0, 1]
  return (
    <div
      className={s.bar}
      style={{
        width: `${100 * pctWidth}%`,
        background: color(prob),
      }}
    />
  );
}

function colorBarGuide() {
  return <div className={s.guide} />;
}
/*
 * Cell for displaying a prediction score/probability or experimental label
 * if the prediction is supported by experimental evidence
 */

const PredictionCell = function({
  /* eslint-disable react/prop-types */
  rowIndex,
  data,
  col,
  color,
  domain,
  colorRange,
  expBar,
  getRow,
  showPercent = true,
  ...props
}) {
  const prediction = getRow ? getRow(rowIndex, data) : data[rowIndex];
  const score = prediction ? prediction[col] : ' ';

  const defaultColor = getColorScale(domain, colorRange);
  if (!color) color = defaultColor; // eslint-disable-line no-param-reassign

  // If prediction is missing or not annotated, use the score.
  // The score will be 'N/A' if the prediction is missing.
  if ((!prediction || !prediction.annotated) && score != null)
    return (
      <Cell {...props}>
        <div style={{ marginBottom: '-5px' }} className={s.score}>
          {isNaN(score) || score === ' ' ? score : score.toFixed(2)}
        </div>
        {colorBarGuide()}
        {colorCell(isNaN(score) ? 0 : score, color, showPercent)}
      </Cell>
    );

  return (
    <Cell className={s.link} style={{ textAlign: 'left' }} {...props}>
      1.0
      <Tooltip text="There is experimental evidence supporting this association">
        <Label style={{ marginLeft: '10px' }} className={s.label}>
          experimental
        </Label>
      </Tooltip>
      {prediction && prediction.pubs && prediction.pubs.length ? (
        <Tooltip text="Number of publications with experimental evidence">
          <Badge style={{ marginLeft: '10px' }}>{prediction.pubs.length}</Badge>
        </Tooltip>
      ) : null}
    </Cell>
  );
};

export default withStyles(s)(PredictionCell);
